package core.validation.validator

import core.dateformat.utils.parseLocalDateOrNull

class DateRangeValidator(
    private val firstValueRequired: Boolean = false,
    private val secondValueRequired: Boolean = false,
) : DoubleValidator<String> {

    override val errorMessage: String
        get() = "The second date must be greater than or equal to the first date."

    override fun validate(
        firstValue: String,
        secondValue: String,
    ): Pair<Boolean, Boolean> {
        val firstDate = parseLocalDateOrNull(firstValue)
        val secondDate = parseLocalDateOrNull(secondValue)

        if (firstDate == null || secondDate == null) {
            return Pair(
                if (firstValueRequired)
                    firstDate != null
                else
                    (firstValue.isEmpty() || firstDate != null),
                if (secondValueRequired)
                    secondDate != null
                else
                    (secondValue.isEmpty() || secondDate != null),
            )
        }

        return Pair(
            true,
            if (secondValueRequired)
                secondDate >= firstDate
            else
                (secondValue.isEmpty() || secondDate >= firstDate),
        )
    }
}
